import { useEffect, useState } from "react";
import api, { euro } from "@/lib/api";
import { SectionTitle, KpiCard } from "@/components/common";
import { Wallet, Users, TrendingUp, CheckCircle2, Clock } from "lucide-react";

export default function ProvvigioniTeam() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/finanza/team-provvigioni").then((r) => setD(r.data)).catch(() => setErr(true)); }, []);

  if (err) return (
    <div className="fade-up" data-testid="provvigioni-team-page">
      <SectionTitle>Provvigioni Team</SectionTitle>
      <div className="card-immo p-8 text-center text-sm text-[var(--muted)] mt-4">Accesso non consentito a questa sezione.</div>
    </div>
  );
  if (!d) return <div className="space-y-4"><div className="skeleton h-10 w-64 rounded-xl" /><div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{[...Array(4)].map((_, i) => <div key={i} className="skeleton h-28 rounded-2xl" />)}</div></div>;

  const t = d.totali || {};
  return (
    <div className="fade-up" data-testid="provvigioni-team-page">
      <SectionTitle sub={`Portafoglio provvigioni ${d.scope === "team" ? "del tuo team" : "dell'agenzia"} in sola lettura. Provvigione lorda, IVA, quota Immobilart, quota agente e netto spettante per agente.`}>Provvigioni Team</SectionTitle>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4 mb-6">
        <KpiCard testid="pt-lorda" label="Provv. lorda totale" value={euro(t.imponibile)} icon={TrendingUp} accent />
        <KpiCard testid="pt-quota-agenzia" label="Quota Immobilart" value={euro(t.quota_agenzia)} icon={Wallet} />
        <KpiCard testid="pt-netto" label="Netto agenti" value={euro(t.netto)} icon={Users} />
        <KpiCard testid="pt-da-incassare" label="Da incassare" value={euro(t.da_incassare)} icon={Clock} />
      </div>

      <div className="card-immo overflow-hidden">
        <div className="p-4 border-b border-[var(--border)] flex items-center gap-2 font-display font-bold"><Users className="text-[#FC82ED]" size={18} /> Dettaglio per agente</div>
        {(!d.agenti || d.agenti.length === 0) ? (
          <div className="p-8 text-center text-sm text-[var(--muted)]">Nessuna provvigione registrata nel team.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[11px] uppercase tracking-wide text-[var(--muted)] border-b border-[var(--border)]">
                  <th className="p-3">Agente</th><th className="p-3 text-right">N.</th>
                  <th className="p-3 text-right">Provv. lorda</th><th className="p-3 text-right">IVA</th>
                  <th className="p-3 text-right">Quota Immobilart</th><th className="p-3 text-right">Quota agente</th>
                  <th className="p-3 text-right">Netto spettante</th><th className="p-3 text-right">Incassato</th><th className="p-3 text-right">Da incassare</th>
                </tr>
              </thead>
              <tbody>
                {d.agenti.map((a) => (
                  <tr key={a.owner_agent_id} data-testid={`pt-row-${a.owner_agent_id}`} className="border-b border-[var(--border)] last:border-0">
                    <td className="p-3 font-semibold">{a.agente_nome}</td>
                    <td className="p-3 text-right mono">{a.provvigioni}</td>
                    <td className="p-3 text-right mono">{euro(a.imponibile)}</td>
                    <td className="p-3 text-right mono text-slate-500">{euro(a.iva)}</td>
                    <td className="p-3 text-right mono">{euro(a.quota_agenzia)}</td>
                    <td className="p-3 text-right mono">{euro(a.quota_agente)}</td>
                    <td className="p-3 text-right mono font-bold text-[#FC82ED]">{euro(a.netto)}</td>
                    <td className="p-3 text-right mono text-emerald-600">{euro(a.incassato)}</td>
                    <td className="p-3 text-right mono">{euro(a.da_incassare)}</td>
                  </tr>
                ))}
                <tr className="bg-slate-50 font-bold">
                  <td className="p-3">Totale team</td><td className="p-3"></td>
                  <td className="p-3 text-right mono">{euro(t.imponibile)}</td>
                  <td className="p-3 text-right mono text-slate-500">{euro(t.iva)}</td>
                  <td className="p-3 text-right mono">{euro(t.quota_agenzia)}</td>
                  <td className="p-3 text-right mono">{euro(t.quota_agente)}</td>
                  <td className="p-3 text-right mono text-[#FC82ED]">{euro(t.netto)}</td>
                  <td className="p-3 text-right mono text-emerald-600">{euro(t.incassato)}</td>
                  <td className="p-3 text-right mono">{euro(t.da_incassare)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
